/* eslint-disable no-irregular-whitespace */
import { useEffect } from 'react';

import Header from './Header/Header';
import Main from './Main/Main';
import Pane from './Main/Pane';
import { StyledEbookContainer, StyledEbookWrapper } from './styled';

import useEbookStore from './store';
import { DATA_CY_EBOOK_PAGE_COMPONENT } from './__tests__/constant';

const Index = () => {
  const {
    ebookDetail: ebook,
    isPaneActive,
    setIsPaneActive,
    setEbookPageViewAsMobile,
    isEbookPageViewAsMobile,
  } = useEbookStore();

  useEffect(() => {
    let timeoutId = null;
    const checkWindowWidth = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const { innerWidth: width } = window;

        if (width <= 796) {
          setEbookPageViewAsMobile(true);
        } else {
          setEbookPageViewAsMobile(false);
        }
      }, 16);
    };

    window.addEventListener('resize', checkWindowWidth);
    window.addEventListener('DOMContentLoaded', checkWindowWidth);
  }, []);

  return (
    <StyledEbookContainer
      isPaneActive={isPaneActive}
      isEbookPageViewAsMobile={isEbookPageViewAsMobile}
      data-cy={DATA_CY_EBOOK_PAGE_COMPONENT}
    >
      <StyledEbookWrapper>
        <Header setIsPaneActive={setIsPaneActive} isPaneActive={isPaneActive} />
        <Main isPaneActive={isPaneActive} />
      </StyledEbookWrapper>

      <StyledEbookWrapper>
        {ebook && isPaneActive && (
          <Pane
            bookTitle={ebook.name}
            bookCover={ebook.image}
            bookDescription={ebook.description}
            downloadCounts={ebook.downloaded}
            downloadName={ebook.file}
          />
        )}
      </StyledEbookWrapper>
    </StyledEbookContainer>
  );
};

export default Index;
